import { render, staticRenderFns } from "./VolunteerProfileNet.vue?vue&type=template&id=cd60c9c0"
import script from "./VolunteerProfileNet.vue?vue&type=script&lang=ts"
export * from "./VolunteerProfileNet.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerProfileNet.vue?vue&type=style&index=0&id=cd60c9c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports